// packages
const { h, Component } = require('preact');
import * as moment from 'moment';

// components
import Lookup from './Lookup/Lookup'

// internal

const asOfDate = moment('2026-03-03', 'YYYY-MM-DD');

class CountyLookup extends Component {
  constructor() {
    super();

    this.state = {}
  }

  render() {
   
    return (
      <div>
        <Lookup />
      </div>
    )
  }
}

export default CountyLookup;
